/* eslint-disable */
import api from '@/utils/api.js'

// 投诉骑手(三方运送)
// token                string    true    "认证token"
// vendorOrderID        string    true    "订单号"
// vendorID             int       true    "订单所属厂商ID"
// waybillVendorID      int       true    "运单所属厂商ID"
// complaintID          int       true    "投诉原因ID"
// waybillID		       	string	  false	  "运单ID"
export const APIComplaintRider = async (string) => {
  try {
    await api('v2/order/ComplaintRider', {
      method: 'POST',
      data: string
    })
  } catch (e) {
    console.error('order/ComplaintRider', e)
    throw e
  }
}

// 查询门店订单扣款记录
/* 
storeIDs	门店ID列表
vendorOrderID	订单ID
vendorIDs	订单所属厂商ID列表
fromTime	开始日期（包含），格式（2006-01-02 00:00:00），如果订单号为空此项必须要求
toTime	结束日期（包含），格式（2006-01-02 23:00:00），如果订单号为空此项必须要求
status	账单状态，0是未结账，1是已结账
type	扣款类型，1为差评补贴，2为优惠券
offset	结果起始序号（以0开始，缺省为0）
pageSize	结果页大小（缺省为50，-1表示全部 
*/
export const APIGetOrdersSupplement = async (query, noLoading = false) => {
  try {
    let res = await api('v2/order/GetOrdersSupplement', {
      method: 'GET',
      params: query,
      noLoading
    })
    return res
  } catch (e) {
    console.error('APIGetOrdersSupplement', e)
    throw e
  }
}

// 新增/修改扣款记录
// payload
/* 
新增
storeID              int        
vendorOrderID     string     
vendorID           string    
type                   int //扣款类型，1为差评订单补贴，2为优惠券
linkID                 int //作为冲账标志关联某条扣款记录，若新增为某一记录的冲账，则此字段填那条记录的id
supplementFee int        //扣款金额
comment           string         //备注

----
修改
id			    int
createdAt            time 	
storeID                int        
vendorOrderID    string     
vendorID             string    
status                  int        //账单状态，若已结账则不允许再修改 ，暂时 0为未结账，1为已结账,-1为作废
linkID                   int        //作为冲账标志关联某条扣款记录
type                     int        //扣款类型，1为差评订单补贴，2为优惠券
supplementFee   int        //扣款金额
billID                   string     //账单ID，后期可能关联账单用
comment            string     //备注
*/
export const APIAddUpdateOrdersSupplement = async (json, noLoading = false) => {
  try {
    let res = await api('v2/order/AddUpdateOrdersSupplement', {
      method: 'POST',
      data: json,
      noLoading
    })
    return res
  } catch (e) {
    console.error('AddUpdateOrdersSupplement', e)
    throw e
  }
}

// 得到订单详情
// vendorOrderID
// vendorID
// refresh
export const APIGetOrderInfo = async (query, noLoading = true) => {
  try {
    let res = await api('v2/order/GetOrderInfo', {
      params: query,
      noLoading
    })
    return res
  } catch (e) {
    console.error('APIGetOrderInfo', e)
    throw e
  }
}

// 查询订单状态
export const orderStatusList = async (query, noLoading = true) => {
  try {
    const res = await api('v2/order/GetOrderStatusList', {
      params: query,
      noLoading
    })
    return res
  } catch (e) {
    throw e
  }
}

export const APIGetMatterOrderStatus = async (json) => {
  try {
    const res = api('v2/jxorder/GetMatterOrderStatus?vendorOrderID=' + json.vendorOrderID, {
      noLoading: true
    })
    return res
  } catch (e) {
    throw e
  }
}

// 重发京东物流
export const APISendFailedMatterOrder = async (json, noLoading = true) => {
  try {
    let res = await api('v2/jxorder/SendFailedMatterOrder', {
      method: 'POST',
      data: json,
      noLoading
    })
    return res
  } catch (e) {
    console.error('SendFailedMatterOrder', e)
    throw e
  }
}


/**
 * 获取门店发票申请 美团
 * @Param	token			  header		string	  true	  "认证token"
 * @Param	storeId			formData	int		    false	  "门店id"
 * @Param	startTime		formData	string	  true	  "开始时间"
 * @Param	endTime			formData	string	  true	  "结束时间"
 * @Param	status			formData	string	  false	  "发票回复状态[1未回复/2回复]"
 * @Param	offset			query		  int		    false	  "结果起始序号（以0开始，缺省为0）"
 * @Param	pageSize		query		  int		    false	  "结果页大小（缺省为50，-1表示全部）"
 */
export const APIGetInvoiceRecord  = async (json,page,noLoading=true) => {
  try {
    let str = ""
    // if(page.offset) str = `offset=${page.offset}`
    // if(page.pageSize) str =  `offset=${page.offset || 0}&pageSize=${page.pageSize || -1}`
    let res = await api(`v2/order/GetInvoiceRecord?${str.length > 0 ? str : ''}`, {
      method: 'POST',
      data: json,
      noLoading
    })
    return res
  } catch (e) {
    console.error('APIGetInvoiceRecord', e)
    throw e
  }
}

/**
 * 上传订单发票
 * @Param	token			    header		string	true	"认证token"
 * @Param	orderId			  formData	string	true	"订单ID"
 * @Param	invoiceUrl		formData	string	true	"发票地址[10M内pdf/png/jpeg/jpg]"
 * @Param	invoiceId		  formData	string	true	"发票号码"
 */
export const APIUploadOrderInvoice   = async (json,noLoading=true) => {
  try {
    let res = await api('v2/order/UploadOrderInvoice', {
      method: 'POST',
      data: json,
      noLoading
    })
    return res
  } catch (e) {
    console.error('UploadOrderInvoice ', e)
    throw e
  }
}


/** 
 *  @Title 上传订单返图图片 https://tscc.meituan.com/home/doc/market/10143
 *  @Description 上传订单拣货图片
 *  @Param	token			header		string	true	"认证token"
 *  @Param	orderId			formData	string  true	"订单ID"
 *  @Param	vendorID		formData	int		true	"平台ID"
 *  @Param	mediaList		formData	string	true	"返图参数"
 * 
 *  @Success 200 {object} controllers.CallResult
 *  @Failure 200 {object} controllers.CallResult
 * 
 *  @mediaList
 * Url              string `json:"url"`
 * Type             int    `json:"type"`
 * ConfigSnapshotId int64  `json:"configSnapshotId"`
 * ItemId           int64  `json:"itemId"`
 * Seq              int    `json:"seq"`
 * InnerSeq         int    `json:"innerSeq"`
 * RequireId        int64  `json:"requireId"`
 * MediaCode        string `json:"mediaCode"`
 */
export const uploadOrderPickingMt    = async (json,noLoading=true) => {
  try {
    let res = await api('v2/jxorder/UploadOrderPicking', {
      method: 'POST',
      data: json,
      noLoading
    })
    return res
  } catch (e) {
    console.error('UploadOrderPicking ', e)
    throw e
  }
}

/**
 * // const cid = "508f0e16259cb377539dedf873fe385e"; // app前端通过unipush获取的cid
		// 	const cloudUrl = "https://fc-mp-b0d2fa7c-b55d-4247-b934-88277443a44f.next.bspapp.com/push";
		// 	const token = "Cc0gZnggRc92aBsNmaZlL93c6IwOgcZycFfL6im7cvLiRuu7mNW7GyT9V797"; // 鉴权token JXC@Push2026Secret

		// 	try {
		// 		const res = await uni.request({
		// 			url: cloudUrl,
		// 			method: "POST",
		// 			header: {
		// 				"Content-Type": "application/json",
		// 				"token": token
		// 			},
		// 			data: {
		// 				cids: [cid],
		// 				title: "前端测试推送",
		// 				content: "这是直接前端调用云函数测试消息",
		// 				data: JSON.stringify({ page: "home" })
		// 			}
		// 		})
		// 		console.log("推送返回结果,9999999999999", res);
		// 	} catch (e) {
		// 		console.error("推送失败", e);
		// 	}

    //         let data:AnyObject = {
    //   afsOrderID: '99999999999999999999',
    //   vendorID: 1,
    //   approveType: 2,
    //   reason:  '同意退款'
 */


/**
 * 获取订单返图详情  https://tscc.meituan.com/home/doc/market/134
 * @Title 获取订单返图详情
 * @Description 获取订单返图详情
 * @Param	token			header		string	true	"认证token"
 * 
 * @Param	orderId			formData	string  true	"订单ID"
 * @Param	vendorID		formData	int		false	"平台ID"
 * 
 * @Success 200 {object} controllers.CallResult
 * @Failure 200 {object} controllers.CallResult
 */
export const getOrderRequirePicture = async (json,noLoading=true) => {
  try {
    let res = await api('v2/jxorder/GetOrderRequirePicture', {
      params: json,
      noLoading
    })
    return res
  } catch (e) {
    console.error('GetOrderPickingDetail ', e)
    throw e
  }
}


// WEBPACK FOOTER //
// ./src/apis/APIOrder.js